
import * as XLSX from 'xlsx';
import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as moment from 'moment';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class ExcelService {

  constructor() { }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const columnWidths = this.calculateColumnWidths(json);
    worksheet['!cols'] = columnWidths;

    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private calculateColumnWidths(json: any[]): { wch: number }[] {
    const headers = Object.keys(json[0] || {});

    const columnWidths: { wch: number }[] = [];
    for (let i = 0; i < headers.length; i++) {
      const header = headers[i];
      let maxDataLength = 0;
      for (let j = 0; j < json.length; j++) {
        const cellValue = json[j][header];
        const cellLength = cellValue ? cellValue.toString().length : 0;
        if (cellLength > maxDataLength) {
          maxDataLength = cellLength;
        }
      }
      columnWidths.push({ wch: Math.max(header.length, maxDataLength) + 2 });
    }
    return columnWidths;
  }
  
  private saveAsExcelFile(buffer: any, fileName: string): void {
     const data: Blob = new Blob([buffer], {type: EXCEL_TYPE});
     FileSaver.saveAs(data, fileName + '_export_' + moment().format('DD/MM/YYYY') + EXCEL_EXTENSION);
  }
}